import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner, Accordion } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import ModalCrud from "./Modal";
import { GetDojoName, GetGradeName } from "../Utils";

export default function ExaminationDetail(props) {
  let params = useParams();
  const dateId = params.id;

  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");
  const [isLoading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [detail, setDetail] = useState(null);
  const [exams, setExams] = useState([]);
  const [examDetail, setExamDetail] = useState(null);
  const [dojos, setDojos] = useState([]);
  const [grades, setGrades] = useState([]);
  const [accountDataFaa, setAccountDataFaa] = useState(null);

  const usuario = JSON.parse(ls.get("userData"));
  const token = JSON.parse(ls.get("jwt"));
  const history = useHistory();

  useEffect(() => {
    GetExams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const GetExams = async () => {
    setLoading(true);

    let dojosList = dojos;
    if (dojosList.length === 0) {
      dojosList = JSON.parse(ls.get("dojos"));
      setDojos(dojosList);
    }
    let gradesList = grades;
    if (gradesList.length === 0) {
      gradesList = JSON.parse(ls.get("grades"));
      setGrades(gradesList);
    }

    const config = await JSON.parse(ls.get("config"));
    setAccountDataFaa(config.accountDataFAA?.replace(/\n/g, "<br/>"));

    const detail = await axios.get(
      `${API_URL}/examinations/${dateId}?populate=examiner`,
      headerRequest
    );
    setDetail(detail.data.data);

    const res = await axios.get(
      `${API_URL}/temp-exams?populate=*&filters[examination][id][$eq]=${dateId}&filters[state][$eq]=DRAFT`,
      headerRequest
    );
    const exams = res.data.data;

    Promise.all(
      exams.map(async (exam) => {
        exam.grade = GetGradeName(gradesList, exam.attributes.grade_id);
        exam.dojo = GetDojoName(dojosList, exam.attributes.dojo_id);

        const tempUser = exam.attributes.tempUser;
        if (tempUser?.data?.id) {
          exam.email = tempUser.data.attributes.email;
          exam.fullname =
            tempUser.data.attributes.lastname +
            ", " +
            tempUser.data.attributes.name;
          exam.tempUserId = tempUser.data.id;
        } else {
          exam.fullname = "Error en Alumno";
        }

        // todo: mejorar con responsableId apuntando a un user
        await axios
          .get(
            `${API_URL}/users/?filters[docNumber][$eq]=${exam.attributes.responsibleDocNumber}`,
            headerRequest
          )
          .then((res) => {
            const userData = res.data[0];
            if (userData) {
              exam.responsable = `${userData.lastname}, ${userData.name}`;
            } else {
              exam.responsable = "Sin responsable";
            }
          })
          .catch((error) => {
            exam.responsable = "";
            console.log("Error find by docNumber:", error);
          });

        // todo: mejorar con createdByUser apuntando a un user
        await axios
          .get(
            `${API_URL}/users/${exam.attributes.createdByUser}`,
            headerRequest
          )
          .then((res) => {
            const userData = res.data;
            if (userData) {
              exam.creador = `${userData.name} ${userData.lastname}`;
            } else {
              exam.creador = "";
            }
          })
          .catch((error) => {
            exam.creador = "";
            console.log("Error find by id:", error);
          });

        return exam;
      })
    ).then((exams) => {
      setExams(exams);
      setLoading(false);
    });
  };

  const ExamEdit = (e) => {
    setExamDetail(e);
    setShowModal(true);
  };

  const ExamDelete = (e) => {
    setLoading(true);
    axios.delete(`${API_URL}/temp-exams/${e.id}`, headerRequest).then(() => {
      if (e.tempUserId) {
        axios
          .delete(`${API_URL}/temp-users/${e.tempUserId}`, headerRequest)
          .then(() => {
            setLoading(false);
            GetExams();
          });
      } else {
        setLoading(false);
        GetExams();
      }
    });
  };

  const renderData = (
    <Table striped hover size="sm" responsive="sm" style={{ fontSize: ".8em" }}>
      <thead>
        <tr>
          <th className="d-none d-md-table-cell">DNI</th>
          <th>Nombre</th>
          <th>Email</th>
          <th>Grado</th>
          <th className="d-none d-lg-table-cell">Dojo</th>
          <th>Responsable</th>
          <th>
            {exams && detail && detail.attributes.quota > exams.length ? (
              <Button
                size="sm"
                variant="success"
                onClick={() => ExamEdit(null)}
              >
                RESERVAR
              </Button>
            ) : (
              <Button disabled variant="outline-secondary">
                CUPO COMPLETO
              </Button>
            )}
          </th>
        </tr>
      </thead>
      <tbody>
        {exams.length < 1 ? (
          <tr>
            <td colSpan="6" align="center">
              No hay reservas.
            </td>
          </tr>
        ) : (
          exams.map((exam) => (
            <tr key={exam.id}>
              <td align="center" className="d-none d-md-table-cell">
                {exam.attributes.docNumber}
              </td>
              <td align="left">{exam.fullname}</td>
              <td align="left">{exam.email}</td>
              <td align="center">{exam.grade}</td>
              <td align="left" className="d-none d-lg-table-cell">
                {exam.dojo}
              </td>
              <td align="left">{exam.responsable}</td>

              {exam.attributes.createdByUser == usuario.id ? (
                <td align="center" className="w140">
                  <Button
                    size="sm"
                    className="btn-xs me-2"
                    onClick={() => ExamEdit(exam)}
                    variant="warning"
                  >
                    Editar
                  </Button>
                  <Button
                    size="sm"
                    className="btn-xs me-2"
                    onClick={() => ExamDelete(exam)}
                    variant="danger"
                  >
                    Borrar
                  </Button>
                </td>
              ) : (
                <td
                  align="center"
                  style={{ color: "#c1c1c1", fontSize: ".8rem" }}
                >
                  {exam.creador}
                </td>
              )}
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3" fluid="lg">
      <p style={{ textAlign: "left" }}>
        <Button size="sm" variant="primary" onClick={history.goBack}>
          VOLVER
        </Button>
      </p>
      <h4>RESERVA DE TURNO PARA EXAMEN</h4>
      {detail ? (
        <>
          <p>
            Fecha: <b>{detail.attributes.date}</b>, Modalidad:{" "}
            <b>{detail.attributes.mode}</b>, Grado:{" "}
            <b>{detail.attributes.rank}</b>, Cupo:{" "}
            <b>{detail.attributes.quota}</b>, Examinador:{" "}
            <b>{detail.attributes.examiner.data.attributes.name}</b>, Lugar:{" "}
            <b>{detail.attributes.place}</b>
          </p>
          <div style={{ textAlign: "left" }}>
            <Accordion
              style={{ maxWidth: "450px", margin: "0 auto" }}
              className="p-1 mb-4"
              flush
            >
              {accountDataFaa && accountDataFaa != "" ? (
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Ver CBU Derecho de Exámen</Accordion.Header>
                  <Accordion.Body>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: accountDataFaa,
                      }}
                    ></div>
                  </Accordion.Body>
                </Accordion.Item>
              ) : null}
              {detail.attributes.examiner.data.attributes?.accountInfo &&
              detail.attributes.examiner.data.attributes.accountInfo != "" ? (
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Ver CBU Examinador</Accordion.Header>
                  <Accordion.Body>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          detail.attributes.examiner.data.attributes.accountInfo.replace(
                            /\n/g,
                            "<br/>"
                          ),
                      }}
                    ></div>
                  </Accordion.Body>
                </Accordion.Item>
              ) : null}
            </Accordion>
          </div>
        </>
      ) : null}
      {isLoading ? <Spinner animation="border" /> : renderData}
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      {showModal && (
        <ModalCrud
          show={showModal}
          id={detail.id}
          date={detail.attributes.date}
          rank={detail.attributes.rank}
          exam={examDetail}
          dojos={dojos}
          grades={grades}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) GetExams();
          }}
        />
      )}
    </Container>
  );
}
